export interface AccountingDateRange { dateFrom: string; dateTo: string; }
export interface AccountingDashboardSummary {
  incomeAmount: number;
  incomeCount: number;
  expenseAmount: number;
  expenseCount: number;
  pendingTransferAmount: number;
  pendingTransferCount: number;
}
export interface AccountingExpenseBreakdown {
  expenseAmount: number;
  commissionAmount: number;
  refundAmount: number;
}
export interface CashFlowBucket { key: string; label: string; income: number; expense: number; }
export interface AccountingDashboardData {
  summary: AccountingDashboardSummary;
  cashFlow: CashFlowBucket[];
  expenseBreakdown: AccountingExpenseBreakdown;
}
export function bangkokDateKey(value: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(value);
  const part = (name: string) => parts.find((item) => item.type === name)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}
export function currentAccountingMonth(): AccountingDateRange {
  const today = bangkokDateKey();
  const [year, month] = today.split('-').map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return { dateFrom: `${today.slice(0, 7)}-01`, dateTo: `${today.slice(0, 7)}-${lastDay}` };
}
export function validDateRange(range: AccountingDateRange): boolean {
  const valid = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    Number.isFinite(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
  return valid(range.dateFrom) && valid(range.dateTo) && range.dateFrom <= range.dateTo;
}
